<template>
  <div class="order-row order-header">
    <div class="order-col has-border sorting" v-for="(label, index) in headers"
      v-bind:key="index" v-bind:class="getClass(label.css_class)">
      <a v-if="label.sort_by" href="#" @click.prevent="toggleDropdown"
        class="dropdown dropdown-toggle"
        :class="{'shown': isOpenSortToggle}" ref="btnToggle">
          <span v-if="!isOpenSortToggle">{{$t(label.tlabel)}}</span>
          <span v-else>Order By</span>
        <svgicon name="icon-down-arrow" width="10" height="10" class="mt-m5" :original="true"/>
      </a>
      <div class="dropdown-menu" v-show="isOpenSortToggle" v-if="label.sort_by">
        <ul class="list-unstyled">
          <div v-for="(option, idx) in getSortOptions(label)" v-bind:key="idx"
            @click="changeSortBy(label, idx)">
            <li class="list-with-icon" v-bind:class="{ 'active active-text':
              sortOptionsCheck[label.key] && sortOptionsCheck[label.key][idx] }">
            <svgicon  v-if="!(sortOptionsCheck[label.key] && sortOptionsCheck[label.key][idx])"
              name="icon-sort" width="12" height="12" :original="true"/>
            <svgicon v-if="sortOptionsCheck[label.key] && sortOptionsCheck[label.key][idx]"
              name="icon-tick-sm" width="8" height="8" :original="true"/>
              {{option.name}}
            <span v-if="sortOptionsCheck[label.key] && sortOptionsCheck[label.key][idx]" class="f-right text-red">Clear</span>
            </li>
          </div>
        </ul>
      </div>
      <div v-else>
        {{label.tlabel ? $t(label.tlabel) : label.label }}
      </div>
    </div>
    <div class="order-col order-action">
      <div class="sorting sorting-light" v-if="showFilterOption">
        <a href="#" @click.prevent="toggleFilterDropdown"
          v-if="!selectedFilterOption"
          class="dropdown dropdown-toggle"
          :class="{'shown': isOpenFilterToggle}" ref="btnToggle">
            <span> {{$t('SORT_BY_ACTION')}}</span>
          <svgicon
            name="fill_arrow"
            width="10" height="10"
            class="mt-m5 ml-5" :original="true"/>
        </a>
        <span class="tagblock" v-if="selectedFilterOption">
         {{$t(selectedFilterOption.tlabel)}}
        <svgicon
          @click="clearFilterSelection"
          name="icon-close" width="8" height="8"
          class="ml-5" :original="true"/>
       </span>
        <div class="dropdown-menu" v-show="isOpenFilterToggle">
          <ul class="list-unstyled text-right">
            <div v-for="(option, idx) in filterOptions" v-bind:key="idx">
              <li class="list-with-icon" @click="updateFilterOption(option)">
              {{$t(option.tlabel)}}
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    headers: {
      type: Array,
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    setSortOptionConfig: null,
    filterOptions: {
      type: Array,
    },
    selectedFilterOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpenSortToggle: false,
      sortOptionsCheck: {},

      isOpenFilterToggle: false,
    };
  },
  methods: {
    getClass(columnClass) {
      return columnClass.toString();
    },
    getSortOptions(header) {
      const result = this.sortOptions.find(option => header.key === option.key);
      return result && result.sort_options;
    },
    toggleDropdown() {
      // eslint-disable-next-line no-sequences
      this.isOpenSortToggle = !this.isOpenSortToggle;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpenSortToggle = false;
      }
    },
    clearSortOptions() {
      this.headers.forEach((header) => {
        if (header.sort_by) {
          const result = this.sortOptions.find(option => header.key === option.key);
          this.sortOptionsCheck[header.key] =
            new Array(result && result.sort_options.length).fill(false);
        }
      });
    },
    changeSortBy(header, index) {
      if (this.sortOptionsCheck[header.key][index]) {
        this.sortOptionsCheck[header.key][index] = false;
        this.$emit('setSortOption', null);
        this.isOpenSortToggle = false;
      } else {
        this.clearSortOptions();
        const result = this.sortOptions.find(option => header.key === option.key);
        const sortBy = result.sort_options[index].sort_by_filter;
        this.sortOptionsCheck[header.key][index] = true;
        this.$emit('setSortOption', sortBy);
        this.isOpenSortToggle = false;
      }
    },

    toggleFilterDropdown() {
      // eslint-disable-next-line no-sequences
      this.isOpenFilterToggle = !this.isOpenFilterToggle;
    },
    updateFilterOption(value) {
      this.$emit('updateFilterOption', value);
      this.toggleFilterDropdown();
    },
    clearFilterSelection() {
      this.$emit('clearFilterOption');
    },
  },
  computed: {
    isPackingIndentEnabled() {
      return this.$hasFeature('packing_indent');
    },
    showFilterOption() {
      return Boolean(this.filterOptions && this.filterOptions.length);
    },
  },
  mounted() {
    this.clearSortOptions();
    if (this.setSortOptionConfig) {
      this.sortOptionsCheck.indent_id[0] = true;
    }
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close);
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.order {
  &-header {
    background-color: #f8f8f8 !important;
    width: 99%;
    position: fixed;
    margin: -50px 0 0 -10px;
    padding: 15px 20px 7.14px 40px;
    z-index: 9 !important;
    .order-col {
      color: #005399;
      font: 1rem "OpenSans-Bold";
      text-transform: uppercase;
      padding:6px 10px 6px 0;
      &.has-border {
        //  border-right: 1px solid #B2C2CB;
      }
      &.order-action{
        width: auto !important;
        margin-left: auto !important;
        margin-right: -10px;
      }
    }
    &.top-sticky{
      border-top: 20px solid #f8f8f8;
      box-shadow: none !important;
      border-bottom: 10px solid #f8f8f8;
    }
  }
}
</style>
